document.addEventListener('change', function (event) {
  const picker = event.target.closest('variant-radios');

  if (!picker || picker.dataset.autoSelecting === 'true') return;

  const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
  const changedFieldset = event.target.closest('fieldset');
  const changedOptionIndex = fieldsets.indexOf(changedFieldset);

  // Only adjust the remaining options when the first option,
  // normally Colour, is changed.
  if (changedOptionIndex !== 0) return;

  const variantJSON = picker.querySelector(
    'script[type="application/json"]'
  );

  if (!variantJSON) return;

  const variants = JSON.parse(variantJSON.textContent);

  const selectedOptions = fieldsets.map((fieldset) => {
    return fieldset.querySelector('input:checked')?.value;
  });

  // Keep the existing selection if it represents an available variant.
  const currentVariant = variants.find((variant) => {
    return variant.available &&
      variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
  });

  if (currentVariant) return;

  // Find available variants belonging to the newly selected colour.
  const availableVariants = variants.filter((variant) => {
    return variant.available &&
      variant.options[0] === selectedOptions[0];
  });

  if (!availableVariants.length) return;

  // Select the closest next available option in the displayed order.
  let chosenVariant = availableVariants[0];

  if (fieldsets[1]) {
    const sizeInputs = Array.from(
      fieldsets[1].querySelectorAll('input[type="radio"]')
    );

    const currentSizeIndex = sizeInputs.findIndex(
      (input) => input.checked
    );

    const orderedSizes = sizeInputs.map((input) => input.value);

    for (let step = 1; step <= orderedSizes.length; step++) {
      const nextIndex =
        (currentSizeIndex + step + orderedSizes.length) %
        orderedSizes.length;

      const nextSize = orderedSizes[nextIndex];

      const matchingVariant = availableVariants.find((variant) => {
        return variant.options[1] === nextSize;
      });

      if (matchingVariant) {
        chosenVariant = matchingVariant;
        break;
      }
    }
  }

  picker.dataset.autoSelecting = 'true';

  chosenVariant.options.forEach((optionValue, index) => {
    const input = Array.from(
      fieldsets[index].querySelectorAll('input[type="radio"]')
    ).find((radio) => radio.value === optionValue);

    if (input) input.checked = true;
  });

  const finalInput = Array.from(
    fieldsets[fieldsets.length - 1].querySelectorAll('input[type="radio"]')
  ).find((radio) => radio.checked);

  if (finalInput) {
    finalInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  picker.dataset.autoSelecting = 'false';
});